import { render, staticRenderFns } from "./presDetail.vue?vue&type=template&id=4381ea32&scoped=true&"
import script from "./presDetail.vue?vue&type=script&lang=js&"
export * from "./presDetail.vue?vue&type=script&lang=js&"
import style0 from "./presDetail.vue?vue&type=style&index=0&id=4381ea32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4381ea32",
  null
  
)

export default component.exports